<script setup lang="ts">
import { computed } from 'vue'
import { cn } from '@/lib/utils'

const props = withDefaults(defineProps<{
  variant?: 'default' | 'outlined' | 'elevated'
  padding?: 'none' | 'sm' | 'md' | 'lg'
  hover?: boolean
  clickable?: boolean
}>(), { variant: 'default', padding: 'md' })

const emit = defineEmits<{ click: [event: MouseEvent] }>()

const paddingClasses = { none: 'p-0', sm: 'p-3', md: 'p-4', lg: 'p-6' }

const variantClasses = computed(() => {
  switch (props.variant) {
    case 'outlined':
      return 'bg-transparent border border-border'
    case 'elevated':
      return 'bg-card border border-border shadow-lg'
    case 'default':
    default:
      return 'bg-card border border-border shadow-xs'
  }
})
</script>

<template>
  <div
    :class="cn(
      'card base-card rounded-xl text-card-foreground transition-all duration-200',
      variantClasses,
      paddingClasses[props.padding],
      props.hover && 'hover:border-line-2',
      props.clickable && 'cursor-pointer active:scale-[0.99]',
    )"
    @click="props.clickable && emit('click', $event)"
  >
    <slot />
  </div>
</template>
